import React from 'react'

import { PressableWithIntent } from '@zet/common/components/pressableWithIntent'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { B2, Icon, XStack, colors as zetColors } from '@zet/design-system'
import { useUserContext } from '@zet/feature-user'
import { i18n } from '@zet/localization'
import { BUTTON_TYPE } from '@zet/utils/Constants'

const EmptyLeadButton = ({
  withFilter = false,
  clearFilters,
  isFromBrand,
}: {
  withFilter?: boolean
  clearFilters?: void
  isFromBrand?: boolean
}) => {
  const navigation = useNavigation()
  const { data: user } = useUserContext()
  return (
    <PressableWithIntent
      type={BUTTON_TYPE.BUTTON}
      name="SellNow"
      onPress={
        withFilter
          ? clearFilters
          : () =>
              navigation.navigate('KnowYourCustomer', {
                source: 'emptyLead',
              })
      }
      className="bg-primary-10 mb-2 w-full rounded border-none py-3"
      eventName="click_action"
      eventPayload={{
        item_name: isFromBrand
          ? 'brand_my_leads_start_selling'
          : 'my_leads_start_selling',
        used_id: user?.id,
      }}
      outlined={true}
    >
      <XStack className="items-center justify-center space-x-2">
        {!withFilter ? (
          <>
            <Icon
              type="RupeeCircleFilled"
              color={zetColors.primary[100]}
              size={24}
            />
            <B2 className="text-primary-100">{i18n.t('myLeads.sell')}</B2>
          </>
        ) : (
          <>
            <Icon type="Filter" color={zetColors.primary[100]} size={24} />
            <B2 className="text-primary-100">{i18n.t('myLeads.clear')}</B2>
          </>
        )}
      </XStack>
    </PressableWithIntent>
  )
}

export default EmptyLeadButton
